import { render, staticRenderFns } from "./CompanyRepresentatives.vue?vue&type=template&id=076ce3e6&scoped=true&"
import script from "./CompanyRepresentatives.vue?vue&type=script&lang=js&"
export * from "./CompanyRepresentatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ce3e6",
  null
  
)

export default component.exports